// Which parts may be sold WITH an old-part trade-in (exchange)?
//
// The superadmin's Exchange Parts page is the single list that decides —
// for supervisor quotes AND for the counter forms' exchange toggle. A part
// is eligible when one of the list's ACTIVE names appears in it, compared
// lowercase with all spaces removed ("Engine" matches "Engine Assembly",
// "gear box" matches "Gearbox").

export const normEx = (t) => String(t || '').toLowerCase().replace(/\s+/g, '');

/** activeNames must already be normalized (see activeExchangeNames). */
export const isExchangeEligible = (partName, activeNames) => {
  const p = normEx(partName);
  return p !== '' && (activeNames || []).some((n) => n && p.includes(n));
};

/** Exchange Parts API rows → normalized ACTIVE names, ready to match. */
export const activeExchangeNames = (rows) =>
  (rows || []).filter((r) => r.is_active !== false).map((r) => normEx(r.name));
